import Image from 'next/image';

import { ICustomIcon } from '@app-types/custom-icons';

import byouWhite from '@assets/byou/byou-white.svg';
import byouPrimary from '@assets/byou/byou.svg';

export enum ByouIconVariant {
    PRIMARY = 'primary',
    WHITE = 'white',
}

interface ByouIconProps extends ICustomIcon<ByouIconVariant> {
    className?: string;
}

export function ByouIcon({ height = 16, variant = ByouIconVariant.PRIMARY, ...props }: Readonly<ByouIconProps>) {
    let image: string;
    switch (variant) {
        case ByouIconVariant.WHITE:
            image = byouWhite;
            break;
        case ByouIconVariant.PRIMARY:
        default:
            image = byouPrimary;
            break;
    }
    return <Image height={height} blurDataURL={image} src={image} alt='B&YOU' priority {...props} />;
}
